// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"334":"ea5a2973","745":"6a070551"}[chunkId] + ".chunk.css";
};